import firebase from "firebase";

export const uploadDoc = (doc, id, filename) => {
  return new Promise((resolve, reject) => {
    if (doc) {
      //Upload File 1
      let ref = "/upload/" + id;
      let uploadTask = firebase
        .storage()
        .ref(ref)
        .child(filename)
        .putString(decodeFromBase64(doc), "data_url", {
          contentType: "image/png",
        });

      return uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          // Handle unsuccessful uploads
          console.error(error);
          reject(error);
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          var pathReference = firebase.storage().ref(ref + "/" + filename);
          pathReference.getDownloadURL().then((downloadURL) => {
            console.log("File available at", downloadURL);
          });
          resolve(ref + "/" + filename);
        },
      );
    }
  });
};

function decodeFromBase64(input) {
  input = input.replace(/\s/g, "");
  return input;
  // return atob(input);
}
